import { useState } from 'react';
import { trpc } from '@/lib/trpc';
import { Modal } from './EnvLayout';
import AdminLoginForm from './AdminLoginForm';
import { ui } from './envUi';

const small = `${ui.btnGhost} !px-2.5 sm:!px-3`;

/**
 * Admin sign-in + edit toggle for a game's top bar.
 *  - `actions`   : buttons for GameShell's `right` slot (Admin → Edit / back / Sign out)
 *  - `editing`   : true while the admin is in the game's editor
 *  - `loginModal`: render this inside the shell
 */
export function useAdminMode(backLabel: string) {
  const utils  = trpc.useUtils();
  const status = trpc.questionnaire.adminStatus.useQuery();
  const admin  = status.data?.admin === true;
  const refreshStatus = () => utils.questionnaire.adminStatus.invalidate();

  const [showLogin, setShowLogin] = useState(false);
  const [editing, setEditing]     = useState(false);

  const logout = trpc.questionnaire.adminLogout.useMutation({
    onSuccess: () => { setEditing(false); refreshStatus(); },
  });

  const actions = admin ? (
    <>
      <button className={small} onClick={() => setEditing(e => !e)}>{editing ? backLabel : 'Edit'}</button>
      <button className={small} disabled={logout.isPending} onClick={() => logout.mutate()}>Sign out</button>
    </>
  ) : (
    <button className={small} onClick={() => setShowLogin(true)}>Admin</button>
  );

  const loginModal = showLogin ? (
    <Modal onClose={() => setShowLogin(false)}>
      <AdminLoginForm onSuccess={() => { setShowLogin(false); refreshStatus(); setEditing(true); }} />
    </Modal>
  ) : null;

  return { admin, editing: editing && admin, actions, loginModal };
}
